module.exports = __webpack_public_path__ + "static/media/me.195eb424.png";